import { Alert } from '@customink/pigment-react';

export const ErrorLoadingAvalaraAlert = () => (
    <Alert severity="error">
        An error occurred while loading the Tax Exemption Certificate form. If the problem persists, contact us.
    </Alert>
);
